import type { BadgeDesignTokens } from '@primeuix/themes/types/badge';

/**
 * Badge component tokens
 *
 * Reference implementation:
 * https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/badge/index.ts
 *
 * Component documentation:
 * https://primeng.org/badge
 */
export const badgeComponentTokens: Partial<BadgeDesignTokens> = {
  colorScheme: {
    light: {
      primary: {
        background: '{blue.500}',
        color: '{white}',
      },
    },
  },
};
